import Xhr from "xhr";
import toPairs from "lodash/toPairs";
import merge from "lodash/merge";
import md5 from "js-md5";
class RequestConfig {
  constructor (token) {
    this.token = token;
  }
  http (url, type, body, headers) {
    if (type.toLowerCase() === "get" && body)
      url =
        url +
        (url.indexOf("?") > -1 ? "&" : "?") +
        toPairs(body)
          .map(v => v.join("="))
          .join("&");
    return new Promise((resolve, reject) => {
      Xhr(
        {
          uri: url,
          method: type,
          headers: {
            ...headers
          },
          body: JSON.stringify(this.handleBodyFormat(body))
        },
        (err, resp) => {
          if (!err && resp.body) {
            var data = JSON.parse(resp.body);
            if (!("code" in data) || data.code === 0) {
              resolve(data.result || data);
              // var result = data.result;
            } else {
              reject(data);
            }
          } else {
            reject(err);
          }
        }
      );
    });
  }
  /**
   * 格式化参数body，统一添加MD5加密
   * @param {*} body 参数体
   * @returns 
   */
  handleBodyFormat(body) {
    const psd = "wefsdfdgdfg";
    let str = "";
    Object.keys(body).map((key, index) => {
      str += index < Object.keys(body).length - 1 ? `${key}=${body[key]}&` :  `${key}=${body[key]}${psd}`;
    });
    return merge({}, body, { sign: md5(str) });
  }
  getB(url, type, body) {
    // ?_stamp=${Date.now()}
    if (location.href.indexOf('localhost') > -1 || location.href.indexOf('127') > -1) {
      window.BASE_URL = 'https://uat-coins-api.palmplaystore.com';
    }
    return this.http(
      `${window.BASE_URL}/coins/${url}`,
      type,
      body,
      {
        // "x-token": this.token,
        // "x-sn": this.sn,
        "Content-Type": "application/json;charset=UTF-8"
      }
    );
  }
  getP(body) {
    return this.http(
      /^ind-/i.test(location.host)
        ? window.PY_ENV.BASE_URL_IND
        : window.PY_ENV.BASE_URL,
      "get",
      merge({}, window.PY_ENV.body, body)
    );
  }
}
export default RequestConfig;